<div class="nb-radio-group" :class="wrapperClass">
  <label
    class="nb-radio"
    v-for="option in options"
    :key="getOptionValue(option)"
    :class="{ active: modelValue === getOptionValue(option) }"
  >
    <input
      type="radio"
      :value="getOptionValue(option)"
      :checked="modelValue === getOptionValue(option)"
      @change="$emit('update:modelValue', getOptionValue(option))"
    />
  
    <div class="nb-icon">
      <span class="iconfont-check" v-if="modelValue === getOptionValue(option)"></span>
    </div>
  
    <!-- parent will provide content -->
    <div class="radio-content">
      <slot :option="option" :checked="modelValue === getOptionValue(option)" />
    </div>
  </label>
</div>
